/**
 * @generated SignedSource<<599017a4865e6a5b9e68b4d11324394c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoEditNewMainMediaComponentRemoveImageMutation$variables = {
  employeeId?: string | null;
  imageId: string;
  todoId: string;
};
export type TodoEditNewMainMediaComponentRemoveImageMutation$data = {
  readonly todo: {
    readonly removeImage: {
      readonly images: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  } | null;
};
export type TodoEditNewMainMediaComponentRemoveImageMutation = {
  response: TodoEditNewMainMediaComponentRemoveImageMutation$data;
  variables: TodoEditNewMainMediaComponentRemoveImageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "imageId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "todoId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "imageId",
    "variableName": "imageId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditNewMainMediaComponentRemoveImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "removeImage",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoEditNewMainMediaComponentRemoveImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "removeImage",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e45477e670daadd3c389a2ecc41a2bf6",
    "id": null,
    "metadata": {},
    "name": "TodoEditNewMainMediaComponentRemoveImageMutation",
    "operationKind": "mutation",
    "text": "mutation TodoEditNewMainMediaComponentRemoveImageMutation(\n  $todoId: ID!\n  $imageId: ID!\n  $employeeId: ID\n) {\n  todo(todoId: $todoId, employeeId: $employeeId) {\n    removeImage(imageId: $imageId) {\n      images {\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "572f984b020a40fe84df180509f679cd";

export default node;
